import { makeStyles } from '@material-ui/core/styles';
import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

const useStyles = makeStyles((theme) => ({
  preamblePageContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    padding: '40px 120px',
    textAlign: 'center',
    [theme.breakpoints.down('md')]: {
      padding: '40px 20px',
    },
  },
  continueButton: {
    padding: '40px',
    [theme.breakpoints.down('sm')]: {
      padding: '20px',
    },
  },
  disclaimerBox: {
    margin: '20px',
  },
  video: {
    width: '612px',
    height: '541px',
    [theme.breakpoints.down('md')]: {
      width: '496px',
      height: '441px',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      height: 'auto',
      maxWidth: '380px',
      maxHeight: '341px',
    },
  },
  image: {
    width: 'auto',
    maxWidth: '100%',
    height: '556px',
    [theme.breakpoints.down('lg')]: {
      height: '472px',
    },
    [theme.breakpoints.down('md')]: {
      height: '411px',
    },
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
      maxHeight: '341px',
    },
  },
  bodyContent: {
    margin: '40px',
    padding: '0px 200px',
    '& p': {
      fontSize: '18px',
      [theme.breakpoints.down('sm')]: {
        fontSize: '14px',
      },
    },
    [theme.breakpoints.down('md')]: {
      margin: '20px',
      padding: '20px',
    },
  },
  textContent: {
    textAlign: 'left',
    margin: '20px',
    '& p': {
      fontSize: '18px',
      [theme.breakpoints.down('sm')]: {
        fontSize: '14px',
        textAlign: 'center',
      },
    },
    [theme.breakpoints.down('md')]: {
      margin: '10px',
      padding: '10px',
    },
  },
  disclaimerContainer: {
    position: 'relative',
    marginTop: '20px',
    [theme.breakpoints.up('md')]: {
      width: '900px',
    },
  },
  disclaimerTitle: {
    position: 'absolute',
    top: '0',
    left: '40px',
    backgroundColor: '#fff',
    padding: '0 5px',
    [theme.breakpoints.down('md')]: {
      left: '20px',
    },
  },
  disclaimerContent: {
    border: '1px solid #ccc',
    borderRadius: '8px',
    maxHeight: '104px',
    overflowY: 'auto',
    padding: '16px',
    marginTop: '10px',
    [theme.breakpoints.down('md')]: {
      padding: '10px',
      marginTop: '5px',
    },
  },
}));

export const PreambleTitleTypography = styled(Typography)(({ theme }) => ({
  fontSize: 48,
  fontWeight: 600,
  [theme.breakpoints.down('md')]: {
    fontSize: 35,
  },
}));

export const PreambleBodyTypography = styled(Typography)(({ theme }) => ({
  fontSize: 24,
  fontWeight: 400,
  [theme.breakpoints.down('md')]: {
    fontSize: 16,
  },
}));

export const PreambleDisclaimerTitleTypography = styled(Typography)(
  ({ theme }) => ({
    fontSize: 12,
    fontWeight: 400,
    [theme.breakpoints.down('md')]: {
      fontSize: 12,
    },
    '&&': {
      color: 'rgba(0, 0, 0, 0.6)',
    },
  }),
);

export default useStyles;
